import { getClassNames } from '@websolutespa/bom-core';
import { useLayout, useMounted } from '@websolutespa/bom-mixer-hooks';
import { AnimatePresence } from 'framer-motion';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { LlmInstance } from '../types';
import { useLlm } from '../useLlm/useLlm';
import { useLlmView } from '../useLlm/useLlmView';
import { CanvasOffscreenProvider } from './components/CanvasOffscreen/canvas-offscreen';
import { Main } from './components/Main/main';
import { Trigger } from './components/Trigger/trigger';
import './scss/style.scss';

type LlmProps = {
};

export const LlmComponent = forwardRef<LlmInstance, LlmProps>((props: LlmProps, ref) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const mounted = useMounted();
  const { locale } = useLayout();
  const { init } = useLlm(state => state.actions);
  const app = useLlm(state => state.app);
  const embed = useLlm(state => state.embed);
  const { initView, initIntersection, open } = useLlmView(state => state.actions);
  const idle = useLlmView(state => state.idle);
  const opened = useLlmView(state => state.opened);
  const introed = useLlmView(state => state.introed);
  const embedded = useLlmView(state => state.embedded);

  useImperativeHandle(ref, () => ({
    open: () => {
      open();
    }
  }));

  useEffect(() => {
    init(locale);
    initView();
  }, [init, locale, initView]);

  useEffect(() => {
    if (innerRef.current) {
      initIntersection(innerRef.current);
    }
  }, [mounted, initIntersection, innerRef.current]);

  useEffect(() => {
    if (!embedded) {
      document.documentElement.style.overflow = opened ? 'hidden' : 'auto';
    }
  }, [opened, embedded]);

  /*
  useEffect(() => {
    if (innerRef.current) {
      const observer = new MutationObserver((mutations) => {
        const target = mutations[0].target as HTMLDivElement;
        const mutatedVars: Partial<LlmVars> = {};
        Object.entries(vars).forEach(([k, v]) => {
          const newValue = target.style.getPropertyValue(k);
          if (v !== newValue) {
            mutatedVars[k] = newValue;
          }
          if (
            k === '--llm-color-base-100' ||
            k === '--llm-color-base-200' ||
            k === '--llm-color-base-300' ||
            k === '--llm-color-base-400'
          ) {
            console.log(k, newValue, v);
          }
        });
        if (Object.keys(mutatedVars).length > 0) {
          setVars(mutatedVars);
        }
      });
      observer.observe(innerRef.current, {
        attributes: true,
        attributeFilter: ['style'],
      });
      return () => observer.disconnect();
    } else {
      return () => { };
    }
  }, []);
  */

  const shouldShowTrigger = (!opened && !idle && !embed) || (app?.contents.customIntro && !introed);

  const classNames = getClassNames('llm', { '-open': opened, '-embedded': embedded });

  if (mounted) {
    return (
      <>
        {app && (
          <CanvasOffscreenProvider>
            <div ref={innerRef} className={classNames} {...props}>
              <AnimatePresence mode="wait" initial={false}>
                {opened && (
                  <Main key="main" />
                )}
              </AnimatePresence>
              <AnimatePresence mode="wait" initial={false}>
                {shouldShowTrigger && (
                  <Trigger key="trigger" />
                )}
              </AnimatePresence>
            </div>
          </CanvasOffscreenProvider>
        )}
      </>
    );
  } else {
    return <></>;
  }
});
